import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=0ab6c945&"
import script from "./Experiments.vue?vue&type=script&lang=js&"
export * from "./Experiments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports